The details of the deleted webhook subscription.
